import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';

/**
 * 후보 선택 면 (퀘스트 7ca8908c) — 섭외 IA §3-3. 조각들을 세로로 잇는다.
 *
 * 폭 558 · 높이 약 350 안에서 스크롤 없이 선다(IA §3-2, 퀘스트 2f546c56). 조각 사이는 8px 다.
 * `position: relative` 는 아래 숨긴 제목이 바깥 스크롤 칸을 건너뛰어 창에 붙지 않게 잡아 둔다.
 */
export const panel = style({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.sm,
});

/**
 * 화면 제목은 바로 위 단계 줄의 「후보 선택」 이 든다(퀘스트 2f546c56 B안). 형제 섹션(지금 답할
 * 회신 · 발송 이력)은 제목을 그대로 세우고, 이 면만 단계 줄이 그 노릇을 한다.
 */
export const srOnly = style({
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
});

export const section = style({
  display: 'flex',
  flexDirection: 'column',
  gap: vars.spacing.gap.xs,
});

export const heading = style({
  margin: 0,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'baseline',
  gap: vars.spacing.gap.sm,
});

export const headingTitle = style({
  fontSize: vars.typography.fontSize.md,
  fontWeight: String(vars.typography.fontWeight.bold),
  color: vars.typography.textColor.primary,
});

export const headingCount = style({
  fontWeight: String(vars.typography.fontWeight.bold),
  color: vars.bright.status.warning,
});

export const note = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.secondary,
});

export const error = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.bright.status.error,
});

export const strong = style({
  color: vars.typography.textColor.primary,
});

export const pager = style({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: vars.spacing.gap.sm,
});

export const footer = style({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: vars.spacing.gap.sm,
});

export const footerEnd = style({
  display: 'flex',
  alignItems: 'center',
  gap: vars.spacing.gap.sm,
  marginLeft: 'auto',
});
